<template>
  <el-dialog :visible.sync="visible" custom-class="work-center-dialog" width="min(520px, calc(100vw - 24px))" :close-on-click-modal="false" append-to-body @closed="onClosed">
    <template slot="title">
      <span>{{ dialogTitle }}</span>
      <span v-if="readonly && form.workCenterId" class="title-actions">
        <el-button v-if="isAuth('base:workCenter:update')" type="primary" size="small" @click="readonly = false">修改</el-button>
        <el-button v-if="isAuth('base:workCenter:delete')" type="primary" size="small" @click="remove">删除</el-button>
      </span>
    </template>
    <el-form ref="dataForm" :model="form" :rules="readonly ? {} : rules" :validate-on-rule-change="false" label-width="100px">
      <el-form-item label="机台编码" prop="workCenterCode"><el-input v-model="form.workCenterCode" :disabled="readonly" /></el-form-item>
      <el-form-item label="机台名称" prop="workCenterName"><el-input v-model="form.workCenterName" :disabled="readonly" /></el-form-item>
      <el-form-item label="所属车间" prop="workShopId">
        <el-select v-model="form.workShopId" filterable style="width:100%" :disabled="readonly">
          <el-option v-for="item in shops" :key="item.workShopId" :label="item.workShopName" :value="item.workShopId" />
        </el-select>
      </el-form-item>
      <el-form-item label="日工时" prop="dailyHours"><el-input-number v-model="form.dailyHours" :min="0.1" :max="24" :precision="1" style="width:100%" :disabled="readonly" /></el-form-item>
      <el-form-item label="并行数"><el-input-number v-model="form.parallelQty" :min="1" :max="1000" :precision="0" style="width:100%" :disabled="readonly" /></el-form-item>
      <el-form-item label="启用">
        <el-radio-group v-model="form.isenabled" :disabled="readonly"><el-radio label="0">启用</el-radio><el-radio label="1">禁用</el-radio></el-radio-group>
      </el-form-item>
      <el-form-item label="备注"><el-input v-model="form.remark" type="textarea" :disabled="readonly" /></el-form-item>
    </el-form>
    <span slot="footer">
      <el-button @click="visible = false">关闭</el-button>
      <el-button v-if="!readonly" type="primary" @click="save">确定</el-button>
    </span>
  </el-dialog>
</template>

<script>
import request from '../../api/request'
import { fetchPerms } from '../../api/auth'

export default {
  name: 'WorkCenterAddOrUpdate',
  data() {
    return {
      visible: false, readonly: false, shops: [], form: this.blank(), permCodes: [],
      rules: {
        workCenterCode: [{ required: true, message: '机台编码不能为空', trigger: 'blur' }],
        workCenterName: [{ required: true, message: '机台名称不能为空', trigger: 'blur' }],
        workShopId: [{ required: true, message: '请选择车间', trigger: 'change' }],
        dailyHours: [{ type: 'number', min: 0.1, max: 24, message: '日工时应在0.1至24小时之间', trigger: 'change' }]
      }
    }
  },
  computed: {
    dialogTitle() {
      if (this.readonly) return '查看机台'
      return this.form.workCenterId ? '修改机台' : '新增机台'
    }
  },
  created() { fetchPerms().then(res => { this.permCodes = res.data || [] }).catch(() => {}) },
  methods: {
    isAuth(perm) {
      const user = this.$store.state.user || {}
      const codes = Array.isArray(user.roleCodes) ? user.roleCodes : []
      if (['TENANT_ADMIN', 'PLATFORM_ADMIN'].indexOf(String(user.roleCode || '')) >= 0 || codes.indexOf('TENANT_ADMIN') >= 0 || codes.indexOf('PLATFORM_ADMIN') >= 0) return true
      return this.permCodes.indexOf(perm) >= 0
    },
    blank() { return { workCenterId: '', workCenterCode: '', workCenterName: '', workShopId: '', dailyHours: 8, parallelQty: 1, isenabled: '0', remark: '' } },
    loadShops() { request.post('/base/workShop/list', { currentPage: 1, pageSize: 500 }).then(res => { this.shops = (res.data && res.data.list) || [] }).catch(() => {}) },
    init(id, readonly, defaults) {
      this.visible = true
      this.readonly = !!readonly
      this.loadShops()
      if (!id) {
        this.form = Object.assign(this.blank(), defaults || {})
        this.$nextTick(() => this.$refs.dataForm && this.$refs.dataForm.clearValidate())
        return
      }
      request.get('/production/workCenter/info', { params: { id } }).then(res => {
        const row = res.data || {}
        this.form = {
          ...this.blank(),
          ...row,
          dailyHours: row.dailyHours == null ? 8 : Number(row.dailyHours),
          parallelQty: row.parallelQty == null ? 1 : Number(row.parallelQty)
        }
        this.$nextTick(() => this.$refs.dataForm && this.$refs.dataForm.clearValidate())
      }).catch(() => {})
    },
    onClosed() { this.form = this.blank(); this.readonly = false },
    save() {
      this.$refs.dataForm.validate(valid => {
        if (!valid) return
        request.post('/production/workCenter/save', this.form).then(() => {
          this.$message.success('操作成功')
          this.visible = false
          this.$emit('refreshDataList')
        }).catch(() => {})
      })
    },
    remove() {
      this.$confirm('确定删除?', '提示', { type: 'warning' }).then(() => {
        request.post('/production/workCenter/delete', { workCenterId: this.form.workCenterId }).then(() => {
          this.$message.success('操作成功')
          this.visible = false
          this.$emit('refreshDataList')
        }).catch(() => {})
      }).catch(() => {})
    }
  }
}
</script>

<style scoped>
.title-actions { float: right; margin-right: 28px; }
</style>

<style>
.work-center-dialog { margin-top: 12px !important; max-height: calc(100vh - 24px); display: flex; flex-direction: column; }
.work-center-dialog .el-dialog__body { min-height: 0; overflow-y: auto; }
.work-center-dialog .el-dialog__header, .work-center-dialog .el-dialog__footer { flex-shrink: 0; }
</style>
